import { Component, OnDestroy } from "@angular/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { assetsConst } from "src/app/core/const/assets.const";
import { VerificationComponent } from "../verification/verification.component";
import { LoginComponent } from "../login/login.component";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/core/services/auth.service";
import { SpinnerService } from "src/app/core/services/spinner.service";
import { ToasterService } from "src/app/core/services/toastr.service";
import { REGEX } from "src/app/core/const/regex.constant";
import { ForgotPassword } from "src/app/models/authmodel";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: "megastore-forgot-password",
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnDestroy {
  assetsConst = assetsConst;
  forgotPasswordFormGroup: FormGroup;
  destroy$: Subject<boolean> = new Subject<boolean>();
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private _spinnerService: SpinnerService,
    private _authService: AuthService,
    private _toasterService: ToasterService,
    private dialog: MatDialog,
    private _translateService: TranslateService,
    private dialogRef: MatDialogRef<LoginComponent>
  ) {
    this.forgotPasswordFormGroup = this.formBuilder.group({
      email: ["", [Validators.required, Validators.pattern(REGEX.Email)]],
    });
  }

  onSubmit(): void {
    this.submitted = true;
    this.forgotPasswordFormGroup.patchValue({
      email: this.forgotPasswordFormGroup.get("email")?.value.trim(),
    });

    if (this.forgotPasswordFormGroup.valid) {
      this.onFormValid(this.forgotPasswordFormGroup.value);
    }
  }

  onFormValid(payload: ForgotPassword): void {
    this._spinnerService.addToLoader("forgotPassword");
    this._authService
      .forgotPassword(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this._spinnerService.removeFromLoader("forgotPassword");
          this._toasterService.successToastr(
            this._translateService.instant("otpSentSuccesss")
          );
          this.dialog.open(VerificationComponent, {
            panelClass: ["modall", "login_nodal"],
            data: {
              ...payload,
              length: 4,
              type: "forgot",
            },
          });
          this.dialogRef.close();
        },
        error: () => {
          this._spinnerService.removeFromLoader("forgotPassword");
        },
      });
  }

  LoginModal(): void {
    this.dialogRef.close();
    this.dialog.open(LoginComponent, {
      panelClass: ["modall", "login_nodal"],
    });
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
